import CatalogManager from "../components/settings/CatalogManager";

export default function WorkshopTypes() {
  return (
    <>
      <div className="h-16 border-b border-border px-8 flex items-center sticky top-0 bg-background/80 backdrop-blur-md z-10">
        <h1 className="font-heading text-xl font-semibold tracking-tight">Typy workshopů</h1>
      </div>
      <div className="p-8" data-testid="workshop-types-page">
        <CatalogManager title="Programy workshopů" endpoint="/admin/programs" hasPrice />
      </div>
    </>
  );
}
